import { en } from "./en";
import { zh } from "./zh";

export type Locale = "en" | "zh";

// The string shape, derived from the English catalog. zh.ts must satisfy this.
export type Strings = typeof en;

export const catalogs: Record<Locale, Strings> = { en, zh };

export const LOCALES: Locale[] = ["en", "zh"];

export function isLocale(v: unknown): v is Locale {
  return v === "en" || v === "zh";
}
